import { createContext, useContext } from 'react';
import type { EsquemaRotina } from '../dicionario/tipos';

export const ContextoEsquema = createContext<EsquemaRotina | null>(null);

export function useEsquemaAtual(): EsquemaRotina {
  const e = useContext(ContextoEsquema);
  if (!e) throw new Error('Página de rotina fora de PaginaRotina');
  return e;
}
